/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_TitleInputs */

const en_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align Right`)
};

const fr_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aligner a Droite`)
};

const de_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtsbündig ausrichten`)
};

const it_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allinea a destra`)
};

const ru_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выровнять справа`)
};

const es_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinear a la derecha`)
};

const zh_cn2_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右对齐`)
};

const ja_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`右揃え`)
};

const hi_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दाईं ओर संरेखित करें`)
};

const pt_pt2_align_right_title = /** @type {(inputs: Align_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhar à direita`)
};

/**
* | output |
* | --- |
* | "Align Right" |
*
* @param {Align_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_title = /** @type {((inputs?: Align_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_right_title(inputs)
	if (locale === "de") return de_align_right_title(inputs)
	if (locale === "it") return it_align_right_title(inputs)
	if (locale === "ru") return ru_align_right_title(inputs)
	if (locale === "es") return es_align_right_title(inputs)
	if (locale === "zh-CN") return zh_cn2_align_right_title(inputs)
	if (locale === "ja") return ja_align_right_title(inputs)
	if (locale === "hi") return hi_align_right_title(inputs)
	if (locale === "pt-PT") return pt_pt2_align_right_title(inputs)
	return en_align_right_title(inputs)
});